import { render, staticRenderFns } from "./AdminCard.vue?vue&type=template&id=0f7c63df&"
import script from "./AdminCard.vue?vue&type=script&lang=js&"
export * from "./AdminCard.vue?vue&type=script&lang=js&"
import style0 from "./AdminCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports